import {
    useState,
    useEffect,
    useContext,
} from 'react';
import axios from 'axios';
import AppContext from './AuthContext';
import { LayoutSplashScreen } from '../../_template/layout/core/MetronicSplashScreen';

export const AuthInit = ({children}) => {
    const {token, agentToken, developerToken, logout, isLoginType, systemAdminToken} = useContext(AppContext);
    const [showSplashScreen, setShowSplashScreen] = useState(true);
    const api_base_url = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const requestUser = async (apiToken) => {
            try {
                setShowSplashScreen(true)
                const api_headers = {
                    headers: { 
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                    }
                };
                await axios.post(`${api_base_url}api/verify-token`, {token: apiToken}, api_headers)
                    .then(async (res) => {
                        if(res.data.status === "error") {
                            logout({
                                type: isLoginType
                            })
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
            } catch (error) {
                logout({
                    type: isLoginType
                });
            } finally {
                setShowSplashScreen(false)
            }
        }
        const tokenMap = {
            E: agentToken,
            A: token,
            D: developerToken,
            SA: systemAdminToken,
        };
        const userToken = tokenMap[isLoginType];

        if (userToken) {
            requestUser(userToken);
        } else {
            logout({ type: isLoginType });
            setShowSplashScreen(false);
        }
    }, [])
    return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}